import React from 'react';
import { useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { isPresent } from 'utils/isPresent';

import { getBannerMessage, getBannerType, getDiscountLabel } from 'components/PayWall/Redux/Selectors';
import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

import { PAY_WALL_VERSION } from './PayWallDialog';

const useStyles = makeStyles(() => ({
  partnerPricingHeader: {
    fontSize: 14,
    fontWeight: 400,
    marginBottom: 20,
  },
}));

export default function PayWallBannerDescription(): JSX.Element {
  const classes = useStyles();

  const bannerMessage = useSelector(getBannerMessage);
  const bannerType = useSelector(getBannerType);

  const discountLabel = useSelector(getDiscountLabel);

  const { trackBannerViewed } = useTrackEventsService();

  if (bannerMessage) {
    trackBannerViewed({
      bannerName: 'PayWall banner',
      message: bannerMessage,
      type: bannerType,
      discount: discountLabel,
      payWallVersion: PAY_WALL_VERSION,
    });
  }

  return (
    <div data-testid="paywall-banner">
      {bannerMessage && (
        <div className={classes.partnerPricingHeader} data-testid="custom-banner">
          <HousecallThemeProvider>
            <Alert severity={bannerType}>
              <Typography variant="body2">{bannerMessage}</Typography>
            </Alert>
          </HousecallThemeProvider>
        </div>
      )}
      {isPresent(discountLabel) && (
        <div className={classes.partnerPricingHeader} data-testid="partner-discount-banner">
          <HousecallThemeProvider>
            <Alert severity="warning">
              <Typography variant="body2">{`Includes a ${discountLabel} preferred partner discount.`}</Typography>
            </Alert>
          </HousecallThemeProvider>
        </div>
      )}
    </div>
  );
}
